import * as React from 'react';
import { useEffect } from 'react';
import { render } from 'react-dom';

import { CollapserUncontrolled } from '../../../components/Collapser';
import { IExtractAndReplaceCollapsersItem } from './extractAndReplaceCollapsers';
import s from '../../../components/post_card/post_card.css';

/**
 * Рендерит и управляет коллапсерами в посте
 */
export const useContentCollapsers = (
  extractedCollapsersItems: Pick<IExtractAndReplaceCollapsersItem, 'id' | 'title' | 'content'>[],
) => {
  useEffect(() => {
    extractedCollapsersItems.forEach(collapser => {
      render(
        <div className={s['collapser-wrapper']}>
          {/* eslint-disable react/no-danger */}
          <CollapserUncontrolled title={<div dangerouslySetInnerHTML={{ __html: collapser.title }} />}>
            <div dangerouslySetInnerHTML={{ __html: collapser.content }} />
          </CollapserUncontrolled>
        </div>,
        document.getElementById(collapser.id),
      );
    });
  }, [extractedCollapsersItems]);
};
